import React from 'react';
import PropTypes from 'prop-types';

import Img from '../../../Img';
import styles from '../collegeCoachActivity.scss';

const LOCK_ICON_SRC = '/img/v2/icons/icon-feature-lock.svg';

const LockedTabContent = ({ summary, headline, testIdPrefix, onUnlock }) => {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onUnlock();
        }
    };

    return (
        <div
            className={styles.lockedPanel}
            role="button"
            tabIndex={0}
            onClick={onUnlock}
            onKeyDown={handleKeyDown}
            data-testid={`${testIdPrefix}.locked`}
        >
            {summary && (
                <div
                    className={styles.lockedSummary}
                    data-testid={`${testIdPrefix}.locked.summary`}
                >
                    {summary}
                </div>
            )}
            {headline && (
                <div
                    className={styles.lockedHeadline}
                    data-testid={`${testIdPrefix}.locked.headline`}
                >
                    {headline}
                </div>
            )}
            <div className={styles.lockRow} data-testid={`${testIdPrefix}.locked.lock-row`}>
                <span
                    className={styles.lockBubble}
                    data-testid={`${testIdPrefix}.locked.lock-bubble`}
                >
                    <Img
                        src={LOCK_ICON_SRC}
                        alt=""
                        className={styles.lockBubbleIcon}
                    />
                </span>
            </div>
        </div>
    );
};

LockedTabContent.defaultProps = {
    summary: null,
    headline: null,
};

LockedTabContent.propTypes = {
    summary: PropTypes.string,
    headline: PropTypes.string,
    testIdPrefix: PropTypes.string.isRequired,
    onUnlock: PropTypes.func.isRequired,
};

export default LockedTabContent;
